import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import TabPanel from './TabPanel.js'
import EditCard from '../EditCard.js'
import DsrPage from '../../Pages/Dsr.js'
import DsrTable from '../Editables/DsrTable.js'

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        minHeight: '90vh',
    },
    tabs: {
        borderRight: `1px solid ${theme.palette.divider}`,
        width: '200px'
    }
}));

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

export default function Dsr() {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className={classes.root}>
            <Tabs
                orientation="vertical"
                indicatorColor="primary"
                variant="scrollable"
                value={value}
                onChange={handleChange}
                aria-label="Vertical tabs example"
                className={classes.tabs}
            >
                <Tab label="Preview" {...a11yProps(0)} />
                <Tab label="Header" {...a11yProps(1)} />
                <Tab label="Carousel" {...a11yProps(2)} />
                <Tab label="Activities" {...a11yProps(3)} />
                <Tab label="DSR Form" {...a11yProps(4)} />
            </Tabs>
            <TabPanel value={value} index={0} preview>
                <DsrPage />
            </TabPanel>
            <TabPanel value={value} index={1} preview={false}>
                <EditCard title="HEADER" textKey="dsr_header" imageKeys={["/images/dsr/dsr.jpg", "/images/dsr/dsr_mob.jpg"]} heading subheading/>
            </TabPanel>
            <TabPanel value={value} index={2} preview={false}>
                <EditCard title="CAROUSEL 1" textKey="dsr_c1_p1" imageKeys={["/images/dsr/poster3.jpg"]} heading subheading titleS="Paragraph 1"/>
                <EditCard title="" textKey="dsr_c1_p2" imageKeys={["/images/dsr/poster4.jpg"]} subheading titleS="Paragraph 2"/>
                <EditCard title="" textKey="dsr_c1_p2" imageKeys={["/images/dsr/poster5.jpg"]} subheading titleS="Paragraph 3"/>
                <EditCard title="CAROUSEL 2" textKey="dsr_c2_p1" imageKeys={["/images/dsr/poster4.jpg"]} heading subheading titleS="Paragraph 1"/>
                <EditCard title="" textKey="dsr_c2_p2" imageKeys={["/images/dsr/poster5.jpg"]} subheading titleS="Paragraph 2"/>
                <EditCard title="" textKey="dsr_c2_p2" imageKeys={["/images/dsr/poster3.jpg"]} subheading titleS="Paragraph 3"/>
            </TabPanel>
            <TabPanel value={value} index={3} preview={false}>
                <EditCard title="ACTIVITIES" textKey="dsr_act_1" imageKeys={["/images/dsr/back1.jpg"]} heading subheading/>
                <EditCard title="YOUTUBE VIDEO" textKey="dsr_act_2" subheading titleS="Youtube Video Link"/>
                <EditCard title="ACTIVITY 1" textKey="dsr_act_1" paragraph titleP="Point 1"/>
                <EditCard title="ACTIVITY 2" textKey="dsr_act_2" paragraph titleP="Point 2"/>
                <EditCard title="ACTIVITY 3" textKey="dsr_act_3" paragraph titleP="Point 3"/>
                <EditCard title="ACTIVITY 4" textKey="dsr_act_4" paragraph titleP="Point 4"/>
                <EditCard title="ACTIVITY 5" textKey="dsr_act_5" paragraph titleP="Point 5"/>
                <EditCard title="ACTIVITY 6" textKey="dsr_act_6" paragraph titleP="Point 6"/>
                <EditCard title="ACTIVITY 7" textKey="dsr_act_7" paragraph titleP="Point 7"/>
                <EditCard title="ACTIVITY 8" textKey="dsr_act_8" paragraph titleP="Point 8"/>
                <EditCard title="ACTIVITY 9" textKey="dsr_act_9" paragraph titleP="Point 9"/>
                <EditCard title="ACTIVITY 10" textKey="dsr_act_10" paragraph titleP="Point 10"/>
                <EditCard title="ACTIVITY 11" textKey="dsr_act_11" paragraph titleP="Point 11"/>
                <EditCard title="ACTIVITY 12" textKey="dsr_act_12" paragraph titleP="Point 12"/>
            </TabPanel>
            <TabPanel value={value} index={4} preview={false}>
                <div style={{padding: '30px'}} ><DsrTable /></div>
            </TabPanel>
        </div>
    );
}
